import Button from 'jd-library/Button';
import SliderWrapper from 'jd-library/SliderWrapper';
import React from 'react';
import InfoBox from './InfoBox';
import './welcome.scss';
import { showVariantTypeSlider } from '../../../actions/variants';
import { connect } from 'react-redux';
import historyHandler from 'jd-library/historyHandler';

const AddVariantWelcome = props => {
    const exampleText = props.isService ? 
            `For variant type 'duration', you can define options as 30 minutes, 60 minutes and 90 minutes.`:
            `For variant type 'size', you can define the options as small, medium and large or 32 Inch, 34 Inch and 36 Inch.`;
    const imgUrl = props.isService ? 'https://image1.jdomni.in/jdomni_email/Vectors_2308071410.jpg' : 'https://image1.jdomni.in/jdomni_email/MultipleVariants_2112271647.png';
    return (
        <SliderWrapper
            onHidden={props.onHidden}
            animateChildren={false}
            header={{
                leftIcons: [{
                    className: "icon-hdrBackNew",
                    onClick: () => {
                      historyHandler.closeCurrent();
                    },
                  }],
                rightIcons: (props.deviceData.isMobile || props.isService) ?  [] : [{
                    className: 'icon-HDRcross',
                    onClick: () => {
                        historyHandler.closeAll(); 
                    }
                }],
            }}
        >
            <div className={'welcome-page'}>
                {/* image */}
                <img src={imgUrl} className={'variant-img'}/>
                <div className={'heading-txt'}>Add Multiple Variants</div>
                <div className={'data-holder'}>
                    <div className={'sub-heading'}>
                        {'To add variants, you need to define multiple variant options in the'} <span>pre-defined</span> {'variant types.'}
                    </div>
                    <InfoBox data={
                        `<span class='highlight-txt'>Example:</span>
                        ${exampleText}`
                    } />
                    <div className={'footer-part'}>
                        <span>To get Started, click on Add Variant Options.</span>
                        <Button className={'add-btn'} clickHandler={() => {
                            historyHandler.closeCurrent();
                            setTimeout(() => {
                                props.showVariantTypeSlider({
                                    show: true,
                                    mode: 'add'
                                })
                            }, 100)
                        }}>Add Variant Options</Button>
                    </div>
                </div>
            </div>
        </SliderWrapper>
    )
};

const mapStateToProps = (state,props) => {
    return {
        deviceData : state.deviceData,
        isService: state.products.editProduct.categoryType == 'service'
    }
}

export default connect(mapStateToProps,{showVariantTypeSlider})(AddVariantWelcome);